import {Route} from 'react-router';
export default Route;
